
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/c89bf0c632f067f6ac8dfb948e27eb43.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-[#5C1A24]/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
          Soluções completas para quem exige perfeição
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
          Unimos experiência técnica e sensibilidade estética para entregar resultados de excelência do conceito à entrega final.
        </p>
        <a 
          href="https://api.whatsapp.com/send/?phone=5511980341891&text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+os+servi%C3%A7os+da+P&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center bg-[#5C1A24] text-white hover:bg-[#4A1520] shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-lg"
        >
          <i className="ri-phone-line mr-2"></i>
          Solicite um orçamento
        </a>
      </div>
    </section>
  );
}